import { BYE } from "../../../publicFunctions/adminDuelHandler";
import { getTrophyUrlForNumberOfMatches } from "../../../publicFunctions/publicHelpers/finalShowdownNaming";
import { getFlagImageUrlByFlagFileName } from "../../../publicFunctions/publicHelpers/imageUrlBuilder";
import {
  getCenteredObjectPosition,
  getFontStyle,
  TBD,
  truncateTitle,
} from "../../../publicFunctions/publicHelpers/tournamentViewHelper";

export function addStoryContainerToPayload(
  finalShowdown,
  isTop,
  match,
  payload,
  zoomLevel,
  storyPositions,
  nightMode,
  sizes,
  mutedUsers,
  matchBoxClass,
  lane,
  row,
  isLaneOnLeft,
  battleId,
  finalistLaneWinner
) {
  let title = "";
  let won = false;
  if (isTop && match.bottomStoryId === BYE) {
    won = true;
  } else if (!isTop && match.topStoryId === BYE) {
    won = true;
  }

  const storyId = isTop ? match.topStoryId : match.bottomStoryId;
  const otherStoryId = isTop ? match.bottomStoryId : match.topStoryId;

  let published = false;
  if (storyId && storyId !== BYE && storyId !== TBD) {
    if (!won) {
      won = match.winner && storyId === match.winner;
    }
    const storyInfo = finalShowdown.storyMap.get(storyId);
    if (storyInfo) {
      title = storyInfo.storyTitle;
      published =
        storyInfo.publishedUserId && !mutedUsers[storyInfo.publishedUserId];
    }
  } else if (storyId && storyId === BYE) {
    title = "This story advances automatically.";
  }

  const positionOfStoryContainer = {
    x: isTop ? storyPositions.topX : storyPositions.bottomX,
    y: isTop ? storyPositions.topY : storyPositions.bottomY,
  };
  if (finalistLaneWinner) {
    // Move the story container up to the top of the match box
    positionOfStoryContainer.y = storyPositions.topY - sizes.matchBoxH;
  }

  {
    /* STORY */
  }
  payload.push(
    <div
      style={{
        position: "absolute",
        width: sizes.storyBoxW.toString(10) + "px",
        height: sizes.storyBoxH.toString(10) + "px",
        top: positionOfStoryContainer.y,
        left: positionOfStoryContainer.x,
        borderRadius: sizes.storyBoxRadius,
        boxShadow: sizes.storyBoxShadow,
        background: nightMode
          ? "rgba(44,44,44,0.98)"
          : "rgba(255,255,255,0.98)",
        transition: "box-shadow 0.2s, border-radius 0.2s",
      }}
      className={!storyId || storyId !== BYE ? matchBoxClass : ""}
      key={
        (finalistLaneWinner
          ? "winnerStory_"
          : isTop
          ? "topStory_"
          : "bottomStory_") +
        lane.toString(10) +
        "_" +
        row.toString(10)
      }
    >
      <div style={{ position: "relative" }}>
        {published ? (
          <a
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "block",
            }}
            href={`story/debrief/${storyId}?uploadedStory`}
            target="_blank"
          >
            <p
              style={getFontStyle(
                sizes.normalFontSize,
                sizes.storyBoxW,
                sizes.storyBoxH,
                nightMode,
                false,
                won
              )}
              className="underline cursor--pointer"
            >
              {truncateTitle(title, zoomLevel)}
            </p>
          </a>
        ) : (
          <p
            style={getFontStyle(
              storyId && storyId === BYE
                ? sizes.smallFontSize
                : sizes.normalFontSize,
              sizes.storyBoxW,
              sizes.storyBoxH,
              nightMode,
              false,
              won
            )}
            className={storyId && storyId === BYE ? "italic" : ""}
          >
            {truncateTitle(title, zoomLevel)}
          </p>
        )}
      </div>
    </div>
  );

  //   SCORE
  if (
    storyId &&
    storyId !== BYE &&
    otherStoryId !== BYE &&
    match.winner &&
    !finalistLaneWinner
  ) {
    const score = match.winner
      ? isTop
        ? match.topScore
        : match.bottomScore
      : "";
    const centeredScorePos = getCenteredObjectPosition(
      {
        x: isLaneOnLeft
          ? (isTop ? storyPositions.topX : storyPositions.bottomX) +
            sizes.storyBoxW -
            sizes.storyCellW
          : isTop
          ? storyPositions.topX
          : storyPositions.bottomX,
        y: isTop ? storyPositions.topY : storyPositions.bottomY,
      },
      { h: sizes.storyBoxH, w: sizes.storyCellW },
      sizes.storyCellW - sizes.smallPadding * 2,
      sizes.storyBoxH - sizes.smallPadding * 2
    );
    payload.push(
      <div
        style={{
          position: "absolute",
          width: sizes.storyCellW.toString(10) + "px",
          height: sizes.storyBoxH.toString(10) + "px",
          top: centeredScorePos.y,
          left: centeredScorePos.x,
        }}
        key={
          (isTop ? "topScore_" : "bottomScore_") +
          lane.toString(10) +
          "_" +
          row.toString(10)
        }
      >
        <div style={{ position: "relative" }}>
          <p
            style={getFontStyle(
              sizes.largeFontSize,
              sizes.storyCellW,
              sizes.storyBoxH,
              nightMode,
              true,
              won
            )}
          >
            {score}
          </p>
        </div>
      </div>
    );
  }

  // FLAG
  if (storyId && storyId !== BYE && storyId !== TBD && !finalistLaneWinner) {
    const centeredFlagPos = getCenteredObjectPosition(
      {
        x: !isLaneOnLeft
          ? (isTop ? storyPositions.topX : storyPositions.bottomX) +
            sizes.storyBoxW -
            sizes.storyCellW
          : isTop
          ? storyPositions.topX
          : storyPositions.bottomX,
        y: isTop ? storyPositions.topY : storyPositions.bottomY,
      },
      { h: sizes.storyBoxH, w: sizes.storyCellW },
      sizes.storyCellW - sizes.smallPadding * 2,
      sizes.storyBoxH - sizes.smallPadding * 2
    );

    const storyInfo = finalShowdown.storyMap.get(storyId);
    const houseInfo = finalShowdown.houseIdToHouseInfo.get(storyInfo.houseId);
    payload.push(
      <div
        style={{
          position: "absolute",
          width: sizes.storyCellW.toString(10) + "px",
          height: sizes.storyBoxH.toString(10) + "px",
          top: centeredFlagPos.y,
          left: centeredFlagPos.x,
        }}
        key={
          (isTop ? "topFlag_" : "bottomFlag_") +
          lane.toString(10) +
          "_" +
          row.toString(10)
        }
      >
        <div style={{ position: "relative" }}>
          <a
            role="button"
            href={
              "/debrief?page=houses&houseId=" +
              houseInfo.houseId +
              "&battleId=" +
              battleId
            }
            target="_blank"
          >
            <img
              style={{ width: sizes.flagW.toString() + "px" }}
              src={getFlagImageUrlByFlagFileName(houseInfo.flagFileName)}
            />
          </a>
        </div>
      </div>
    );
  }

  // Place Winner Text and Trophy under the story container
  if (finalistLaneWinner) {
    payload.push(
      <div
        key={"winnerText_" + lane.toString(10) + "_" + row.toString(10)}
        style={{
          position: "absolute",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "4px",
          fontWeight: "bold",
          top: positionOfStoryContainer.y + sizes.storyBoxH,
          left: positionOfStoryContainer.x + sizes.storyBoxW / 2.7,
        }}
      >
        <p
          style={{
            fontSize: sizes.largeFontSize,
            color: nightMode ? "#c2c4c2" : "inherit",
          }}
        >
          WINNER
        </p>
        <img
          src={getTrophyUrlForNumberOfMatches(1)}
          alt="Finalist Trophy"
          style={{ height: sizes.trophyHeight }}
        />
      </div>
    );
  }
}
